module.exports = __webpack_public_path__ + "static-portal/img/022.ff202af.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/022.jpg
// module id = 0vBe
// module chunks = 4